module.exports = __webpack_public_path__ + "img/台南市.676ca591.png";